import { Text } from '@change/ds-core-ui';

import { Translate } from '@change-corgi/core/react/i18n';

import { ResponsiveBox } from 'src/app/pages/petitionGamma/details/shared/components';

import { PetitionUrlQRCode as PetitionUrlQRCodeSunrise } from '../QRCodeSunrise';

import { ShareLoader } from './ShareLoader';

export function SharePetition() {
	return (
		<div className="px-0" data-qa="share-section-sunrise">
			<Text variant="heading" size="large">
				<Translate value="corgi.petition_gamma.share.title" />
			</Text>
			<div className="mt-6 flex flex-col gap-6 md:flex-row">
				<PetitionUrlQRCodeSunrise />
				<div className="w-full">
					<ResponsiveBox viewportSize="small">
						<ShareLoader forMobileView />
					</ResponsiveBox>
					<ResponsiveBox viewportSize="normal">
						<ShareLoader forMobileView={false} />
					</ResponsiveBox>
				</div>
			</div>
		</div>
	);
}
